module.exports = __webpack_public_path__ + "img/gas_meter.2a1c5025.svg";